import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

const GOLD = '#D4AF37';
const BG_CARD = '#0a0f1e';
const BORDER = 'rgba(255,255,255,0.06)';
const TEXT_SEC = '#6b7280';

const HomeIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
    <path d="M9 21V12h6v9" />
  </svg>
);
const CalIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const ClientsIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.85" />
  </svg>
);
const SettingsIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const MoreIcon = ({ size = 22, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

// More sheet SVG icons
const WaitlistSVG = ({ color = '#D4AF37' }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    <line x1="19" y1="8" x2="23" y2="8"/><line x1="21" y1="6" x2="21" y2="10"/>
  </svg>
);
const PackagesSVG = ({ color = '#D4AF37' }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);
const AddonsSVG = ({ color = '#D4AF37' }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
);
const ReferralsSVG = ({ color = '#D4AF37' }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/>
    <polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>
  </svg>
);
const GiftCardsSVG = ({ color = '#D4AF37' }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
    <path d="M12 7c-1.5-2-4-2-4 0s2.5 2 4 2 4 0 4-2-2.5-2-4-2z" opacity="0.5" strokeWidth="1.4"/>
  </svg>
);
const TaxSVG = ({ color = '#D4AF37' }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);

const MORE_ITEMS = [
  { to: '/dash/waitlist', label: 'Waitlist', Icon: WaitlistSVG },
  { to: '/dash/packages', label: 'Packages', Icon: PackagesSVG },
  { to: '/dash/addons', label: 'Add-ons', Icon: AddonsSVG },
  { to: '/dash/referrals', label: 'Referrals', Icon: ReferralsSVG },
  { to: '/dash/gift-cards', label: 'Gift Cards', Icon: GiftCardsSVG },
  { to: '/dash/tax', label: 'Tax', Icon: TaxSVG },
];

const ICON_MAP = { home: HomeIcon, cal: CalIcon, clients: ClientsIcon, settings: SettingsIcon, more: MoreIcon };

const sidebarLinks = [
  { to: '/dash', label: 'Home', iconKey: 'home', exact: true },
  { to: '/dash/appointments', label: 'Bookings', iconKey: 'cal' },
  { to: '/dash/clients', label: 'Clients', iconKey: 'clients' },
  { to: '/dash/settings', label: 'Settings', iconKey: 'settings' },
];

const moreLinks = [
  { to: '/dash/waitlist', label: 'Waitlist', Icon: WaitlistSVG },
  { to: '/dash/packages', label: 'Packages', Icon: PackagesSVG },
  { to: '/dash/addons', label: 'Add-ons', Icon: AddonsSVG },
  { to: '/dash/referrals', label: 'Referrals', Icon: ReferralsSVG },
  { to: '/dash/gift-cards', label: 'Gift Cards', Icon: GiftCardsSVG },
  { to: '/dash/tax', label: 'Tax', Icon: TaxSVG },
];

const bottomTabs = [
  { to: '/dash', path: '/dash', label: 'Home', iconKey: 'home', exact: true },
  { to: '/dash/appointments', path: '/dash/appointments', label: 'Bookings', iconKey: 'cal', pending: true, noViewParam: true },
  { to: '/dash/clients', path: '/dash/clients', label: 'Clients', iconKey: 'clients' },
  { to: '/dash/settings', path: '/dash/settings', label: 'Settings', iconKey: 'settings' },
  { label: 'More', iconKey: 'more', isMore: true },
];

export default function AdminSidebar() {
  const [pendingCount, setPendingCount] = useState(0);
  const [showMoreSheet, setShowMoreSheet] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { username, logout } = useAuth();
  const handleLogout = () => { logout(); navigate('/dash/login'); };

  useEffect(() => {
    api.get('/appointments/pending').then(r => setPendingCount(r.data.length)).catch(() => {});
  }, [location.pathname]);

  // Close sheet on navigation
  useEffect(() => { setShowMoreSheet(false); }, [location.pathname]);

  function isTabActive(tab) {
    if (tab.exact) return location.pathname === tab.path;
    if (!tab.path || !location.pathname.startsWith(tab.path)) return false;
    if (tab.noViewParam) {
      const v = new URLSearchParams(location.search).get('view');
      return !v || v === 'pending';
    }
    return true;
  }

  const isMoreActive = moreLinks.some(l => location.pathname.startsWith(l.to));

  return (
    <>
      {/* Desktop sidebar */}
      <aside className="admin-sidebar-desktop" style={{ background: BG_CARD, borderRight: `1px solid ${BORDER}` }}>
        <div style={{ padding: '20px 20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: GOLD }}>{username || 'Mane'}</span>
          <button onClick={handleLogout} style={{ background: 'rgba(255,255,255,0.04)', border: `1px solid ${BORDER}`, color: TEXT_SEC, fontSize: 11, cursor: 'pointer', padding: '4px 10px', borderRadius: 6, fontWeight: 600 }}>
            Sign out
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 8px' }}>
          {sidebarLinks.map(({ to, label, iconKey, exact }) => {
            const Icon = ICON_MAP[iconKey];
            return (
              <NavLink key={to} to={to} end={exact} style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
                color: isActive ? GOLD : TEXT_SEC, background: isActive ? 'rgba(212,175,55,0.08)' : 'transparent',
                borderRadius: 10, textDecoration: 'none', fontSize: 13, fontWeight: isActive ? 700 : 500,
              })}>
                {({ isActive }) => <><Icon size={18} color={isActive ? GOLD : TEXT_SEC} />{label}</>}
              </NavLink>
            );
          })}
          {/* More section on desktop */}
          <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${BORDER}` }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.08em', padding: '0 14px 6px' }}>More</div>
            {moreLinks.map(({ to, label, Icon }) => (
              <NavLink key={to} to={to} style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px',
                color: isActive ? GOLD : TEXT_SEC, background: isActive ? 'rgba(212,175,55,0.08)' : 'transparent',
                borderRadius: 10, textDecoration: 'none', fontSize: 13, fontWeight: isActive ? 700 : 400,
              })}>
                {({ isActive }) => <><Icon color={isActive ? GOLD : TEXT_SEC} />{label}</>}
              </NavLink>
            ))}
          </div>
        </div>
      </aside>

      {/* More sheet overlay */}
      {showMoreSheet && (
        <>
          <div onClick={() => setShowMoreSheet(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 99998, backdropFilter: 'blur(4px)' }} />
          <div style={{
            position: 'fixed', bottom: 64, left: 0, right: 0, zIndex: 99999,
            background: 'linear-gradient(180deg, #111827 0%, #0d1117 100%)',
            borderRadius: '24px 24px 0 0',
            border: '1px solid rgba(255,255,255,0.08)', borderBottom: 'none',
            padding: '16px 16px 24px',
            boxShadow: '0 -16px 48px rgba(0,0,0,0.7)',
          }}>
            {/* Handle bar */}
            <div style={{ width: 40, height: 4, background: 'rgba(255,255,255,0.15)', borderRadius: 2, margin: '0 auto 20px' }} />
            {/* Title */}
            <div style={{ fontSize: 11, fontWeight: 700, color: '#4b5563', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 14, paddingLeft: 4 }}>
              More Features
            </div>
            {/* Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
              {moreLinks.map(({ to, label, Icon }) => {
                const active = location.pathname.startsWith(to);
                return (
                  <Link key={to} to={to} style={{ textDecoration: 'none' }}>
                    <div style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                      padding: '18px 8px 14px', borderRadius: 16, gap: 10,
                      background: active ? 'rgba(212,175,55,0.08)' : 'rgba(255,255,255,0.03)',
                      border: `1px solid ${active ? 'rgba(212,175,55,0.25)' : 'rgba(255,255,255,0.06)'}`,
                      transition: 'all 0.15s',
                    }}>
                      <div style={{
                        width: 48, height: 48, borderRadius: 14,
                        background: active ? 'rgba(212,175,55,0.12)' : 'rgba(255,255,255,0.04)',
                        border: `1px solid ${active ? 'rgba(212,175,55,0.2)' : 'rgba(255,255,255,0.06)'}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        <Icon color={active ? GOLD : '#6b7280'} />
                      </div>
                      <span style={{ fontSize: 11, fontWeight: 600, color: active ? GOLD : '#9ca3af', textAlign: 'center', letterSpacing: '0.02em' }}>{label}</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </>
      )}

      {/* Mobile bottom tab bar */}
      <nav id="admin-bottom-nav" style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        height: 'calc(64px + env(safe-area-inset-bottom, 20px))',
        background: '#080d18', borderTop: `1px solid ${BORDER}`,
        zIndex: 99999,
        paddingBottom: 'max(env(safe-area-inset-bottom, 20px), 20px)',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.8)',
        display: 'flex', alignItems: 'flex-start', paddingTop: 8,
      }}>
        {bottomTabs.map((tab) => {
          const active = tab.isMore ? isMoreActive || showMoreSheet : isTabActive(tab);
          const Icon = ICON_MAP[tab.iconKey];
          return (
            <div
              key={tab.label}
              onClick={tab.isMore ? () => setShowMoreSheet(v => !v) : undefined}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4, position: 'relative', cursor: 'pointer' }}
            >
              {tab.isMore ? (
                <>
                  {active && <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: 32, height: 2, background: GOLD, borderRadius: '0 0 2px 2px', boxShadow: `0 0 8px ${GOLD}` }} />}
                  <Icon size={22} color={active ? GOLD : TEXT_SEC} />
                  <span style={{ fontSize: 9, fontWeight: active ? 700 : 500, color: active ? GOLD : TEXT_SEC, textTransform: 'uppercase', letterSpacing: '0.04em' }}>More</span>
                </>
              ) : (
                <Link to={tab.to} style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4, textDecoration: 'none', position: 'relative', touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}>
                  {active && <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: 32, height: 2, background: GOLD, borderRadius: '0 0 2px 2px', boxShadow: `0 0 8px ${GOLD}` }} />}
                  <Icon size={22} color={active ? GOLD : TEXT_SEC} />
                  <span style={{ fontSize: 9, fontWeight: active ? 700 : 500, color: active ? GOLD : TEXT_SEC, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{tab.label}</span>
                  {tab.pending && pendingCount > 0 && (
                    <span style={{ position: 'absolute', top: 8, right: 'calc(50% - 16px)', background: '#ef4444', color: '#fff', fontSize: 9, fontWeight: 800, minWidth: 16, height: 16, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px' }}>
                      {pendingCount}
                    </span>
                  )}
                </Link>
              )}
            </div>
          );
        })}
      </nav>
    </>
  );
}
